import { DateTime, Settings } from 'luxon';

export const formatDate = (iso?: string | null, format = 'LLL dd, yyyy') => {
  if (!iso) {
    return '';
  }

  try {
    let newIso = iso.trim();

    // Correct the datetime formats by replacing 't' with 'T' if necessary
    if (newIso.includes('t')) {
      newIso = newIso.replace(/t/g, 'T');
    }
    if (newIso.includes(' ')) {
      newIso = newIso.replace(/ /g, 'T');
    }

    // If the timestamp does not have a time zone, treat it as UTC
    if (!newIso.endsWith('Z') && !newIso.includes('+') && !newIso.includes('-')) {
      newIso += 'Z';
    }

    return DateTime.fromISO(newIso, { zone: 'utc' }).toFormat(format);
  } catch (_) {
    return '';
  }
};

// Function to check if date is 24 hours old
export const isDate24HoursOld = (date: string) => {
  const dateToCheck = new Date(date);
  const now = new Date();
  const diff = now.getTime() - dateToCheck.getTime();
  const hours = diff / 1000 / 60 / 60;

  return hours < 24;
};

/**
 * Calculates a formatted "time ago" string representing the difference between
 * start and end dates.
 * e.g.: "1yr ago"
 *
 * https://moment.github.io/luxon/#/math?id=diffs
 */
export const calcTimeAgo = (start: string, end: string) => {
  Settings.throwOnInvalid = true;

  let startISO: DateTime;
  let endISO: DateTime;

  try {
    startISO = DateTime.fromISO(start);
    endISO = DateTime.fromISO(end);
  } catch (_) {
    return 'Invalid date';
  }

  const { years, months, weeks, days } = endISO
    .diff(startISO, ['years', 'months', 'weeks', 'days'])
    .toObject();

  if (years && years >= 1) {
    return `${Math.floor(years)}yr ago`;
  }
  if (months && months >= 1) {
    return `${Math.floor(months)}mo ago`;
  }
  if (weeks && weeks >= 1) {
    return `${Math.floor(weeks)}w ago`;
  }
  if (days && days >= 1) {
    return `${Math.floor(days)}d ago`;
  }

  return 'Today';
};

export const formatNotesDate = (isoDate: string) => {
  if (!isoDate) return '';
  const date = new Date(isoDate);

  return date.toLocaleDateString('default', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
